import defaultsPlugin from 'store/plugins/defaults';
import engine from 'store/src/store-engine';
import sessionStorageType from 'store/storages/sessionStorage';
export var sessionStorage = engine.createStore([sessionStorageType], [defaultsPlugin]);
//# sourceMappingURL=index.js.map